export default __webpack_public_path__ + "static/media/smallColoredLogoBankzz.03996ab5.svg";